import { PowerBIEmbed } from 'powerbi-client-react';
import { useEffect, useRef, useState } from 'react';
import { models } from 'powerbi-client';
import { useLocation } from 'react-router-dom';
import { showSnackbar } from '../../../redux/snackbarSlice';
import { useGetDatasetRefreshStatusQuery, usePostDatasetRefreshRequestMutation, useGetReportsInWorkspaceQuery } from '../../../api/power-bi/powerbiApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { apiSlice } from '../../../api/apiSlice';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';
import useWindowDimensions from '../../../utils/useWindowDimensions';

const PowerBiPage = () => {
    // Reference to store the embedded report
    const reportRef = useRef(null);

    const location = useLocation()
    const dispatch = useDispatch()

    const selectedAccount = useSelector(getSelectedAccount)

    // Event Handlers
    const handleLoaded = () => console.log('Report loaded');
    const handleRendered = () => console.log('Report rendered');
    const handleError = (event) => {
        dispatch(apiSlice.util.invalidateTags("[Reports]"))
    };
    const handleVisualClicked = () => console.log('visual clicked');
    const handlePageChanged = (event) => console.log(event);



    const [isPolling, setIsPolling] = useState(false);
    const [postRefresh] = usePostDatasetRefreshRequestMutation();
    const [pollingInterval, setPollingInterval] = useState(0);

    const { data: refreshStatus } = useGetDatasetRefreshStatusQuery(
        { datasetId: location.state.DatasetId },
        { skip: !isPolling, pollingInterval }
    );

    // Polling interval control based on `isPolling` status
    useEffect(() => {
        setPollingInterval(isPolling ? 3000 : 0);
    }, [isPolling]);

    // Initial post request on page mount to check if a refresh is needed
    useEffect(() => {
        const initiateRefresh = async () => {
            if (location.state.DatasetId) {
                const result = await postRefresh({ datasetId: location.state.DatasetId }).unwrap();

                if (result) {
                    dispatch(showSnackbar({ message: "Dataset refresh in progress... ", severity: "info" }));
                    setIsPolling(true);
                } else {
                    setIsPolling(false);
                }
            }
        };
        
        initiateRefresh();
    }, [location.state.DatasetId, postRefresh, dispatch]);

    // Polling response: stop polling and show success snackbar if data is up-to-date
    useEffect(() => {
        if (refreshStatus) {
            setIsPolling(false);
            dispatch(showSnackbar({ message: "Please reload page to see latest data.", severity: "info" }));
        }
    }, [refreshStatus, dispatch]);
    
    const { height, width } = useWindowDimensions();
    const {data: monitorReports} = useGetReportsInWorkspaceQuery({accountId: selectedAccount.AccountId}, {skip: !selectedAccount.AccountId});

    // Select the report that matches the page you are on.
    const embedReport = monitorReports?.filter(report => report.Id == location.state.ReportId)[0]

    return (embedReport?.EmbedToken && <PowerBIEmbed
            embedConfig={{
                type: 'report',
                id: embedReport.Id,
                embedUrl: embedReport.EmbedUrl,
                accessToken: embedReport.EmbedToken,
                tokenType: models.TokenType.Embed,
                settings: {
                    panes: {
                        filters: {
                            expanded: false,
                            visible: false
                        }
                    },
                    background: models.BackgroundType.Transparent,
                    navContentPaneEnabled: false,
                    zoomLevel: width / 2000
                    
                }
            }}
            eventHandlers={
                new Map([
                    ['loaded', handleLoaded],
                    ['rendered', handleRendered],
                    ['error', handleError],
                    ['visualClicked', handleVisualClicked],
                    ['pageChanged', handlePageChanged],
                ])
            }
            cssClassName="reportClass"
            getEmbeddedComponent={(embeddedReport) => {
                // Store the embedded report reference
                reportRef.current = embeddedReport;
            }}
        />
    );
};

export default PowerBiPage;
